// extracted by mini-css-extract-plugin
export default {"container":"OrderCancelledProducts_container__+SbEB"};